module.exports = __webpack_public_path__ + "media/images/contact_us_clouds-40eb8148.png";